import * as React from 'react';
import * as style from './style.css';
import { Icon3DTour16, Tooltip } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var Features = function Features(_ref) {
  var features = _ref.features;
  if (features.length === 0) {
    return null;
  }
  var feature3D = features.find(function (feature) {
    return feature.type === '3d';
  });
  if (!feature3D) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    children: /*#__PURE__*/_jsx("div", {
      className: style['feature'],
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        title: feature3D.description,
        children: /*#__PURE__*/_jsx(Icon3DTour16, {
          color: "white_100"
        })
      })
    })
  });
};